import { onMount } from "@/modules/_";
import gsap from "@lib/gsap";

export default function (element: HTMLElement, dataset: DOMStringMap) {
  const overlayPath = element.querySelector("[data-overlay-path]");
  onMount(() => {
    gsap.to(element, {
      opacity: 1,
      duration: 1,
      ease: "none",
    });

    gsap.from(element.querySelector("path"), {
      strokeDasharray: "0, 0",
      duration: 5,
    });

    // draw path on element scroll
    gsap.from(overlayPath, {
      drawSVG: 0,
      duration: 1,
      ease: "none",
      scrollTrigger: {
        trigger: element,
        start: "top 70%",
        end: "bottom 70%",
        scrub: true,
        // markers: true,
      },
    });
  });
}
